export const ru = {
  // Navigation (Russian)
  explore: 'Исследовать',
  search: 'Поиск',
  create: 'Создать пост',
  messages: 'Сообщения',
  notifications: 'Уведомления',
  settings: 'Настройки',
  profile: 'Профиль',
  logout: 'Выйти',
  home: 'Главная',
  
  // Authentication
  signin: 'Войти',
  signup: 'Регистрация',
  login: 'Войти',
  register: 'Регистрация',
  email: 'Электронная почта',
  password: 'Пароль',
  confirmPassword: 'Подтвердить пароль',
  firstName: 'Имя',
  lastName: 'Фамилия',
  forgotPassword: 'Забыли пароль?',
  alreadyHaveAccount: 'Уже есть аккаунт? Войдите',
  dontHaveAccount: 'Нет аккаунта? Зарегистрируйтесь',
  
  // Posts & Content
  recent: 'Недавние',
  trending: 'В тренде',
  popular: 'Популярное',
  like: 'Нравится',
  likes: 'Нравится',
  comment: 'Комментарий',
  comments: 'Комментарии',
  share: 'Поделиться',
  delete: 'Удалить',
  edit: 'Редактировать',
  post: 'Пост',
  posts: 'Посты',
  title: 'Заголовок',
  content: 'Содержание',
  tags: 'Теги',
  noBlogsFound: 'Блоги не найдены. Попробуйте поискать что-то другое или создайте первый!',
  
  // AI Assistant
  quickActions: 'Быстрые действия',
  writeCaption: 'НАПИСАТЬ ПОДПИСЬ',
  suggestTopics: 'ПРЕДЛОЖИТЬ ТЕМЫ',
  improveContent: 'УЛУЧШИТЬ КОНТЕНТ',
  creativeIdeas: 'ТВОРЧЕСКИЕ ИДЕИ',
  clearChat: 'ОЧИСТИТЬ ЧАТ',
  aiWritingAssistant: 'ИИ-помощник по письму',
  poweredByGroq: 'Работает на GROQ AI',
  aiGreeting: 'Привет! Я ваш ИИ-помощник по письму. Я могу помочь вам создавать увлекательный контент, писать подписи, предлагать темы для постов и улучшать ваше письмо. Над чем бы вы хотели поработать сегодня?',
  askMeToHelp: 'Попросите меня помочь с контентом, подписями, темами или письмом...',
  aiThinking: 'ИИ думает...',
  
  // Chat & Messages
  chat: 'Чат',
  noConversationsYet: 'Пока нет разговоров',
  ideafluxChat: 'Чат IdeaFlux',
  typeMessage: 'Введите сообщение...',
  sendMessage: 'Отправить сообщение',
  connectingToChat: 'Подключение к чату...',
  
  // Notifications
  noNotificationsYet: 'Пока нет уведомлений.',
  markAllRead: 'Отметить все как прочитанные',
  clearAll: 'Очистить все',
  
  // Settings
  accountSettings: 'Настройки аккаунта',
  displayName: 'Отображаемое имя',
  emailAddress: 'Адрес электронной почты',
  languagePreference: 'Предпочтение языка',
  privacySecurity: 'Конфиденциальность и безопасность',
  notificationPreferences: 'Настройки уведомлений',
  allowDirectMessages: 'Разрешить прямые сообщения',
  letOthersMessage: 'Разрешить другим пользователям отправлять вам личные сообщения',
  likesOnPosts: 'Лайки на постах',
  commentsOnPosts: 'Комментарии к постам',
  newFollowers: 'Новые подписчики',
  mentions: 'Упоминания',
  save: 'Сохранить',
  deleteAccount: 'Удалить аккаунт',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'Получать уведомления, когда кто-то',
  likesYourPosts: 'лайкает ваши посты',
  commentsOnYourPosts: 'комментирует ваши посты',
  followsYou: 'подписывается на вас',
  mentionsYou: 'упоминает вас',
  chooseNotifications: 'Выберите, какие уведомления вы хотите получать',
  controlWhoInteracts: 'Контролируйте, кто может взаимодействовать с вами',
  manageAccountInfo: 'Управляйте информацией и настройками вашего аккаунта',
  emailCannotBeChanged: 'Email нельзя изменить по соображениям безопасности',
  
  // Common
  loading: 'Загрузка...',
  cancel: 'Отмена',
  update: 'Обновить',
  submit: 'Отправить',
  back: 'Назад',
  next: 'Далее',
  previous: 'Предыдущий',
  online: 'В сети',
  offline: 'Не в сети',
  
  // Profile
  editProfile: 'РЕДАКТИРОВАТЬ ПРОФИЛЬ',
  noBioYet: 'Пока нет биографии.',
  followers: 'Подписчики',
  following: 'Подписки',
  recentActivity: 'Недавняя активность',
  noPostsYet: 'Пока нет постов',
  shareFirstPost: 'Поделитесь своим первым постом!',
  bio: 'Биография',
  dateOfBirth: 'Дата рождения',
  follow: 'Подписаться',
  unfollow: 'Отписаться',
  
  // Search
  discover: 'Открыть',
  findPeopleStories: 'Найдите людей, истории и идеи, которые важны для вас',
  searchByName: 'Поиск по имени, заголовку или #тегу...',
  searchResults: 'Результаты поиска',
  noResultsFound: 'Результаты не найдены',
  peopleFound: 'Найдены люди',
  
  // Settings - Additional keys
  enterDisplayName: 'Введите ваше отображаемое имя',
  saving: 'Сохранение...',
  confirmDeleteAccount: 'Вы уверены, что хотите удалить свой аккаунт? Это действие нельзя отменить.',
  accountDeletedSuccessfully: 'Аккаунт успешно удален.',
  errorDeletingAccount: 'Ошибка при удалении аккаунта. Попробуйте еще раз.',
  settingsSavedSuccessfully: 'Настройки успешно сохранены!',
  failedToSaveSettings: 'Не удалось сохранить настройки. Попробуйте еще раз.',
  
  // Form component
  pleaseSignInToCreate: 'Войдите, чтобы создать пост.',
  titleRequired: 'Заголовок обязателен для публикации поста.',
  contentRequired: 'Содержание истории обязательно для публикации поста.',
  contentTooShort: 'Содержание истории должно быть не менее 10 символов.',
  postUpdatedSuccessfully: 'Пост успешно обновлен!',
  postPublishedSuccessfully: 'Пост успешно опубликован!',
  pleaseSignInToCreateBlogs: 'Войдите, чтобы создать свои собственные блоги IdeaFlux.',
  enterEngagingTitle: 'Введите увлекательный заголовок...',
  story: 'История',
  writeYourMasterpiece: 'Напишите свой шедевр...',
  addTags: 'Добавить теги...',
  add: 'Добавить',
  publishPost: 'Опубликовать пост',
  
  // Post component
  linkCopiedToClipboard: 'Ссылка скопирована в буфер обмена! Счетчик репостов обновлен.',
  youAndOthers: 'Вы и еще {{count}}',
  unknownUser: 'Неизвестный пользователь',
  noImage: 'Нет изображения',
  deletePost: 'Удалить пост',
  confirmDeletePost: 'Вы уверены, что хотите удалить этот пост?',
};